import Vue from "vue";
// import VueAnalytics from "vue-analytics";
import VueGtag from "vue-gtag";
import VueMeta from "vue-meta";
import router from "./router";
import store from "./store";
import axios from "axios";
import VueAxios from "vue-axios";
import { BootstrapVue, IconsPlugin } from "bootstrap-vue";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import "./scss/style.scss";
import "./style.css";
import "./css/classy-nav.css";
import "./css/t-datepicker.min.css";
import "./css/themes/t-datepicker-blue.css";
import AOS from "aos";
import "aos/dist/aos.css";
import App from "./App.vue";

Vue.config.productionTip = false;

// Vue.use(VueAnalytics, {
//   id: "G-4VX4TRPC24",
//   router,
// });
Vue.use(VueGtag, { config: { id: "G-4VX4TRPC24" } }, router);

Vue.use(VueMeta, {
  // optional pluginOptions
  refreshOnceOnNavigation: true,
});
Vue.use(VueAxios, axios);
Vue.use(require("vue-moment"));

AOS.init();
// Install BootstrapVue
Vue.use(BootstrapVue);
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin);
new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
